module.exports = __webpack_public_path__ + "static/img/left.398aa46.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/images/left.png
// module id = qm4d
// module chunks = 1